import { render, staticRenderFns } from "./transferPage.vue?vue&type=template&id=570ffa22&scoped=true"
import script from "./transferPage.vue?vue&type=script&lang=js"
export * from "./transferPage.vue?vue&type=script&lang=js"
import style0 from "./transferPage.vue?vue&type=style&index=0&id=570ffa22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ffa22",
  null
  
)

export default component.exports